const getAnswerVariant = (variant: string): string => {
	if (variant === 'radio') return 'RadioButtonAnswerPage'
	else if (variant === 'checkbox') return 'MultipleChoiceAnswerPage'
	else if (variant === 'slider') return 'SliderAnswerPage'
	else if (variant === 'basic') return 'BasicDetailsAnswerPage'
	return ''
}

export default getAnswerVariant
